<template>

</template>

<script setup lang="ts">

const addDishAfterActionCookie = useCookie('add_dish_after', {
    watch: 'shallow',
})
const { mutate } = useAddToBasket()
const { data: receptionWay } = useCurrentReceptionWay()
const { userCredentials } = useUserCredentials()

const addCartItem = () => {
    if(addDishAfterActionCookie.value && parseInt(addDishAfterActionCookie.value) > 0) {
        mutate({
            dish_id: parseInt(addDishAfterActionCookie.value),
            quantity: 1,
            dish_name: ""
        })

        addDishAfterActionCookie.value = null
    }
}

watch(receptionWay, async (newReceptionWay, oldReceptionWay) => {
    if (!oldReceptionWay && newReceptionWay) {
        addCartItem()
    }
})

</script>
